import { ApiEnvelope } from '../../../types';
import {
    DrChronoTask,
    DrChronoTaskStatus,
    EnrollmentHistoryEntry,
    MemberClinicalData,
    PortalLink
} from '../types';

/**
 * A real `clinical/` response (2026-10-12). Kept verbatim because DrChrono's shapes are
 * easy to idealise: empty allergy descriptions, null dosage fields, microsecond timestamps.
 */
export const memberClinicalDataMock: ApiEnvelope<MemberClinicalData> = {
    status: 'success',
    message: '',
    data: {
        conditions: [
            {
                id: 17,
                drchrono_id: 109593929,
                source_visit_id: null,
                name: 'Bilateral primary osteoarthritis of hip',
                icd_code: 'M16.0',
                icd_version: 10,
                snomed_ct_code: null,
                status: 'active',
                date_onset: '2026-10-12',
                date_diagnosis: '2026-10-12',
                date_changed: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.286289+00:00',
                removed_at: null
            },
            {
                id: 20,
                drchrono_id: 109593942,
                source_visit_id: null,
                name: 'Diabetes mellitus due to underlying condition with hyperosmolarity without nonketotic hyperglycemic-hyperosmolar coma (NKHHC)',
                icd_code: 'E08.00',
                icd_version: 10,
                snomed_ct_code: null,
                status: 'active',
                date_onset: '2026-10-12',
                date_diagnosis: '2026-10-12',
                date_changed: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.286289+00:00',
                removed_at: null
            },
            {
                id: 19,
                drchrono_id: 109593934,
                source_visit_id: null,
                name: 'Essential (primary) hypertension',
                icd_code: 'I10',
                icd_version: 10,
                snomed_ct_code: null,
                status: 'active',
                date_onset: '2026-10-12',
                date_diagnosis: '2026-10-12',
                date_changed: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.286289+00:00',
                removed_at: null
            },
            {
                id: 18,
                drchrono_id: 109593930,
                source_visit_id: null,
                name: 'Moderate persistent asthma, uncomplicated',
                icd_code: 'J45.40',
                icd_version: 10,
                snomed_ct_code: null,
                status: 'active',
                date_onset: '2026-10-12',
                date_diagnosis: '2026-10-12',
                date_changed: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.286289+00:00',
                removed_at: null
            }
        ],
        medications: [
            {
                id: 14,
                drchrono_id: 198692620,
                source_visit_id: null,
                name: 'fluticasone furoate 100 mcg/actuation blister powder for inhalation',
                rxnorm: '1547658',
                ndc: '66993016797',
                status: 'active',
                dosage_quantity: null,
                dosage_units: null,
                frequency: null,
                route: null,
                prn: true,
                date_prescribed: null,
                date_started_taking: null,
                date_stopped_taking: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.315448+00:00',
                removed_at: null
            },
            {
                id: 12,
                drchrono_id: 198692616,
                source_visit_id: null,
                name: 'lisinopril 20 mg tablet',
                rxnorm: '314077',
                ndc: '00591040801',
                status: 'active',
                dosage_quantity: null,
                dosage_units: null,
                frequency: null,
                route: null,
                prn: true,
                date_prescribed: null,
                date_started_taking: null,
                date_stopped_taking: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.315448+00:00',
                removed_at: null
            },
            {
                id: 13,
                drchrono_id: 198692617,
                source_visit_id: null,
                name: 'meloxicam 15 mg tablet',
                rxnorm: '152695',
                ndc: '68382005101',
                status: 'active',
                dosage_quantity: null,
                dosage_units: null,
                frequency: null,
                route: null,
                prn: true,
                date_prescribed: null,
                date_started_taking: null,
                date_stopped_taking: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.315448+00:00',
                removed_at: null
            },
            {
                id: 11,
                drchrono_id: 198692615,
                source_visit_id: null,
                name: 'metformin 850 mg tablet',
                rxnorm: '861010',
                ndc: '65862000901',
                status: 'active',
                dosage_quantity: null,
                dosage_units: null,
                frequency: null,
                route: null,
                prn: true,
                date_prescribed: null,
                date_started_taking: null,
                date_stopped_taking: null,
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.315448+00:00',
                removed_at: null
            }
        ],
        allergies: [
            {
                id: 10,
                drchrono_id: 28879414,
                source_visit_id: null,
                description: '',
                reaction: 'Shortness of breath/difficulty breathing',
                rxnorm: null,
                snomed_reaction: '267036007',
                status: 'active',
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.344878+00:00',
                removed_at: null
            },
            {
                id: 11,
                drchrono_id: 28879419,
                source_visit_id: null,
                description: '',
                reaction: null,
                rxnorm: '1191',
                snomed_reaction: null,
                status: 'active',
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.344878+00:00',
                removed_at: null
            },
            {
                id: 12,
                drchrono_id: 28879421,
                source_visit_id: null,
                description: '',
                reaction: null,
                rxnorm: '10169',
                snomed_reaction: null,
                status: 'active',
                notes: null,
                last_synced_at: '2026-10-12T09:42:16.344878+00:00',
                removed_at: null
            }
        ],
        flags: [],
        appointment_needed: [],
        last_synced_at: '2026-10-12T09:42:16.344878+00:00'
    }
};

export const drChronoTaskStatusesMock: ApiEnvelope<DrChronoTaskStatus[]> = {
    status: 'success',
    message: '',
    data: [
        { id: 2, name: 'Open', status_category: 'O' },
        { id: 3, name: 'In progress', status_category: 'O' },
        { id: 4, name: 'Closed', status_category: 'C' }
    ]
};

export const drChronoTasksMock: ApiEnvelope<DrChronoTask[]> = {
    status: 'success',
    message: '',
    data: [
        {
            id: 98765,
            title: 'Confirm updated heart-failure med list',
            status_id: 2,
            priority: 20,
            category_id: 12,
            assignee_user_id: 501,
            assignee_group_id: null,
            due_at: null,
            archived: false,
            notes: [],
            drchrono_created_at: '2026-07-28T14:05:00+00:00',
            drchrono_updated_at: '2026-07-28T14:05:00+00:00'
        },
        {
            id: 98712,
            title: 'Order home BP cuff replacement',
            status_id: 4,
            priority: null,
            category_id: 12,
            assignee_user_id: null,
            assignee_group_id: 77,
            due_at: '2026-07-20T16:00:00+00:00',
            archived: false,
            notes: [
                {
                    id: 4410,
                    text: 'Shipped via clinic supply order.',
                    archived: false,
                    created_by: 501,
                    created_at: '2026-07-16T09:12:00+00:00'
                }
            ],
            drchrono_created_at: '2026-07-15T10:30:00+00:00',
            drchrono_updated_at: '2026-07-16T09:12:00+00:00'
        }
    ]
};

export const enrollmentHistoryMock: ApiEnvelope<EnrollmentHistoryEntry[]> = {
    status: 'success',
    message: '',
    data: [
        {
            id: 3,
            program: 'RTM',
            status: 'enrolled',
            effective_date: '2026-08-01T00:00:00Z',
            changed_by: 42,
            reason: 'Re-enrolled after device replacement',
            episode_id: 11,
            drchrono_task_id: 98770,
            created_at: '2026-08-01T06:00:00Z'
        },
        {
            id: 2,
            program: 'RTM',
            status: 'disenrolled',
            effective_date: '2026-07-15T00:00:00Z',
            changed_by: null,
            reason: 'Patient request',
            episode_id: 10,
            drchrono_task_id: null,
            created_at: '2026-07-15T14:00:00Z'
        },
        {
            id: 1,
            program: 'RTM',
            status: 'enrolled',
            effective_date: '2026-05-01T00:00:00Z',
            changed_by: 42,
            reason: 'Clinical note locked',
            episode_id: 10,
            drchrono_task_id: 98765,
            created_at: '2026-05-01T06:00:00Z'
        }
    ]
};

export const portalLinkMock: ApiEnvelope<PortalLink | null> = {
    status: 'success',
    message: '',
    data: {
        id: 1,
        token: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        is_active: true,
        generated_at: '2026-09-13T10:00:00Z',
        last_accessed_at: '2026-09-14T09:30:00Z'
    }
};

/**
 * Swap these in for the fixtures above to review the empty states — they mirror
 * the documented "member has no linked DrChrono patient" response.
 */
export const emptyMemberClinicalDataMock: ApiEnvelope<MemberClinicalData> = {
    status: 'success',
    message: '',
    data: {
        conditions: [],
        medications: [],
        allergies: [],
        flags: [],
        appointment_needed: [],
        last_synced_at: null
    }
};

export const emptyEnrollmentHistoryMock: ApiEnvelope<EnrollmentHistoryEntry[]> = {
    status: 'success',
    message: '',
    data: []
};

export const emptyPortalLinkMock: ApiEnvelope<PortalLink | null> = {
    status: 'success',
    message: '',
    data: null
};
